<script setup>
import { computed } from "vue";

const props = defineProps({
  editing: { type: Boolean, default: false },
  saving: { type: Boolean, default: false },
  canSave: { type: Boolean, default: false },
  statusText: { type: String, default: "View mode" },
  statusTone: { type: String, default: "idle" },
  editLabel: { type: String, default: "Edit" },
  saveLabel: { type: String, default: "Save Changes" },
  cancelLabel: { type: String, default: "Cancel" },
});

const emit = defineEmits(["edit", "save", "cancel"]);

const statusClasses = computed(() => {
  if (props.statusTone === "saving") {
    return "border-sky-200 bg-sky-50 text-sky-700 dark:border-sky-900/60 dark:bg-sky-950/30 dark:text-sky-200";
  }
  if (props.statusTone === "error") {
    return "border-rose-200 bg-rose-50 text-rose-700 dark:border-rose-900/60 dark:bg-rose-950/30 dark:text-rose-200";
  }
  if (props.statusTone === "dirty") {
    return "border-amber-200 bg-amber-50 text-amber-800 dark:border-amber-900/60 dark:bg-amber-950/30 dark:text-amber-200";
  }
  return "border-slate-200 bg-slate-50 text-slate-600 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-300";
});
</script>

<template>
  <div class="flex flex-wrap items-center justify-end gap-2">
    <span
      class="inline-flex rounded-full border px-3 py-1 text-xs font-semibold"
      :class="statusClasses"
    >
      {{ statusText }}
    </span>
    <button
      v-if="!editing"
      class="btn"
      type="button"
      @click.prevent="emit('edit')"
    >
      {{ editLabel }}
    </button>
    <template v-else>
      <button
        class="btn cancel"
        type="button"
        :disabled="saving"
        @click.prevent="emit('cancel')"
      >
        {{ cancelLabel }}
      </button>
      <button
        class="btn save"
        type="button"
        :disabled="saving"
        :class="{ 'opacity-70': !canSave && !saving }"
        @click.prevent="emit('save')"
      >
        <span v-if="saving" class="inline-flex items-center gap-2">
          <span class="inline-block h-4 w-4 animate-spin rounded-full border-2 border-white/40 border-t-white"></span>
          Saving...
        </span>
        <span v-else>{{ saveLabel }}</span>
      </button>
    </template>
  </div>
</template>
